import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (errorMsg == 'ERR_SESSION_EXPIRED') return;
		if (errorMsg == 'ERR_DATABASE_FOUND') {
			window.location.href = '/database/notFound';
			return;
		}
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		toast.error("An error occurred!");
	}
};

export default toastError;